import { FieldKey } from '../types';
import Lab2MetricsReporter from '@cdo/apps/lab2/Lab2MetricsReporter';
import { getValidateAndSetFieldValueWithInvalidValueLogger } from './validateAndSetFieldValue';
import { generateAiEffectBlocks } from './generateAiEffectBlocks';
var validateAndSetFieldValue = getValidateAndSetFieldValueWithInvalidValueLogger(function (_a) {
    var message = _a.message, value = _a.value, logValues = _a.logValues;
    return Lab2MetricsReporter.logWarning({ message: message, value: value, field: logValues });
});
/**
 * Generates blocks from the AI result in a given workspace,
 * and attaches them to each other.
 */
export var generateAiEffectBlocksFromResult = function (workspace, effect) {
    var blocksSvg = generateAiEffectBlocks(workspace);
    // Foreground block.
    validateAndSetFieldValue(blocksSvg[0].getField('EFFECT'), effect.foregroundEffect, { logValues: FieldKey.FOREGROUND_EFFECT });
    // Background block.
    validateAndSetFieldValue(blocksSvg[1].getField('EFFECT'), effect.backgroundEffect, { logValues: FieldKey.BACKGROUND_EFFECT });
    validateAndSetFieldValue(blocksSvg[1].getField('PALETTE'), effect.backgroundColor, { logValues: FieldKey.BACKGROUND_PALETTE });
    // Connect the blocks.
    blocksSvg[0].nextConnection.connect(blocksSvg[1].previousConnection);
    return blocksSvg;
};
